import { defineComponent as a, computed as o, openBlock as c, createElementBlock as r, createElementVNode as t, toDisplayString as d, createCommentVNode as _, normalizeStyle as f } from "vue";
const h = ["viewBox"], m = /* @__PURE__ */ t("mask", { id: "33b58b96-393c-4b29-9a97-5549e833de8d" }, [
  /* @__PURE__ */ t("circle", {
    cx: "256",
    cy: "256",
    r: "256",
    fill: "#fff"
  })
], -1), u = { mask: "url(#33b58b96-393c-4b29-9a97-5549e833de8d)" }, k = { key: 0 }, g = /* @__PURE__ */ t("path", {
  fill: "#496e2d",
  d: "M0 0h512v512H0z"
}, null, -1), p = /* @__PURE__ */ t("circle", {
  cx: "200.3",
  cy: "256",
  r: "111.3",
  fill: "#d80027"
}, null, -1), v = { fill: "none" }, x = ["r"], W = /* @__PURE__ */ a({
  __name: "bd",
  props: {
    flagName: {},
    strokeColor: { default: "#000" },
    strokeWidth: { default: 0 }
  },
  setup(i) {
    const e = i, l = o(() => 512 + 2 * e.strokeWidth), s = o(() => -e.strokeWidth), n = o(() => 256 + e.strokeWidth / 2);
    return (b, w) => (c(), r("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      class: "svg-circle-flags",
      viewBox: `${s.value} ${s.value} ${l.value} ${l.value}`
    }, [
      m,
      t("g", u, [
        e.flagName ? (c(), r("title", k, d(e.flagName), 1)) : _("", !0),
        g,
        p
      ]),
      t("g", v, [
        t("circle", {
          cx: "256",
          cy: "256",
          r: n.value,
          fill: "none",
          style: f({ stroke: e.strokeColor, strokeWidth: e.strokeWidth })
        }, null, 12, x)
      ])
    ], 8, h));
  }
});
export {
  W as default
};
//# sourceMappingURL=bd-0fc66c88.js.map
